<template>
  <div>
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-6">
            <h4>{{ stock.id }} {{ stock.name }} <br>{{ stock.company }}</h4>
          </div>
          <div class="col-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }"><feather type="home"></feather></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/stock/board' }">Stock</router-link>
              </li>
              <li class="breadcrumb-item active">Intraday {{ date }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-xl-12 box-col-12">
          <div class="card">
            <highcharts class="chartWrapper" :constructor-type="'stockChart'" :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      ticker: this.$route.params.ticker,
      stock: null,
      ohlc: [],
      vol: [],
      chartOptions: {
        chart: {
          zoomType: 'x',
          height: 600
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        yAxis: [{
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'OHLC'
          },
          height: '60%',
          lineWidth: 2,
          resize: {
            enabled: true
          }
        }, {
          labels: {
            align: 'right',
            x: -3
          },
          title: {
            text: 'Volume'
          },
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 2
        }],
        tooltip: {
          split: true
        },
        credits: { enabled: false },
        series: [{
          type: 'candlestick',
          name: '',
          id: '',
          data: []
        }, {
          type: 'column',
          name: 'Volume',
          data: [],
          yAxis: 1
        }]
      },
    }
  },
  computed: {
    title: function () { return this.stock ? this.stock.id+' '+this.stock.name+' : '+this.stock.company : 'Historical' }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.match(this.ticker)
    },
    match(ticker) {
      this.stock = this.$store.state.menu.stocks.find(s => s.id===ticker || s.name===ticker)
      this.chartOptions.title.text = this.stock.id+' '+this.stock.name+' : '+this.stock.company
      this.chartOptions.subtitle.text = '2021'
      this.chartOptions = { ...this.chartOptions }
      this.fetchData()
    },
    fetchData() {
      this.$http.get('/api/stock/historical/'+this.stock.name)
          .then(({data}) => {
            this.ohlc = data.data.map(d => ([d[0], d[1], d[2], d[3], d[4]]))
            this.vol = data.data.map(d => ([d[0], d[5]]))
            this.chartOptions.series[0].name = this.stock.name
            this.chartOptions.series[0].id = this.stock.id
            this.chartOptions.series[0].data = this.ohlc
            this.chartOptions.series[1].data = this.vol

            this.chartOptions = { ...this.chartOptions }
          })
          .catch(e => console.log(e.message))
    }
  }
}
</script>

<style >
.chartWrapper {
  position: relative;
  overflow-x: auto;
  width: 100%;
}

.chartContainer {
  position: relative;
}
</style>